import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import MoreVertOutlinedIcon from "@material-ui/icons/MoreVertOutlined";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Select from '@mui/material/Select';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import Tooltip from '@mui/material/Tooltip';
import { v4 as uuidv4 } from 'uuid';

import { changeAccount, changeSelRole } from "../redux";
import {
  signOut,
  searchAccount,
  setAccount,
  generateCourseCode,
  addInstructor,
} from "../firebaseApi";
import InstructorCourseSettings from "./InstructorCourseSettings";
import InstructorCourseEnrollment from "./InstructorCourseEnrollment";
import InstructorCourseExportSelect from "./InstructorCourseExportSelect";
import InstructorCourseExport from "./InstructorCourseExport";
import InstructorCourseOverride from "./InstructorCourseOverride";
import InstructorLockoutMenu from "./InstructorLockoutMenu";
import InstructorUnlockSelect from "./InstructorUnlockSelect";
import InstructorRefreshDialog from "./InstructorRefreshDialog";
import SelectRole from "./SelectRole";
import AdminInterface from "./AdminInterface";
import {
  Button,
  TextField,
  // Select,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@material-ui/core";
import SettingsRemoteIcon from "@material-ui/icons/SettingsRemote";
import AddBoxIcon from "@material-ui/icons/AddBox";
import Collapse from "@material-ui/core/Collapse";
import { getTableHeadUtilityClass, ListItemButton } from "@mui/material";

const styles = (theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  
  drawer: {
    width: 260,
    zIndex: 1,
  },
  search: {
    margin: "5px 12px 12px 12px",
  },
});

class InstructorMenu extends Component {
  constructor(props) {
    super(props);
    //console.log("InstructorMenu Constructor", this.props);

    this.state = {
      course: null,
      courseAnchorEl: null,
      courseSettingsOpen: false,
      courseOverrideOpen: false,
      courseLockoutOpen:false,
      courseSelectUnlockOpen:false,
      courseEnrollmentOpen: false,
      courseExportOpen: false,
      exportSelectOpen: false,
      courseDashboardOpen: false,
      allCoursesShown: false,
      courseExportSessions: [],
      adminDropdown: false,
      search: "",
      searchResult: {},
      correctOnly: false,
      searchResultConfirmData: {},
      showSearchResultConfirmDialog: false,
      anonVotes:false,
      selectedStudent: {},
      clonedCourse: null,
      unlockStudent: false,
      openRefreshDialog: false,
      anonCourseDialogOpen: false,
      unlockStudent: false,
      adminInterfaceOpen: false,
      addInstructorEmail: "",
      addInstructorError: false,
      addInstructorHelper: "",
    };
  }


  render() {
    let mobile = this.props.width === "sm" || this.props.width === "xs";
    return (
      <div>
        <Drawer
          disableEnforceFocus
          classes={{ paper: this.props.classes.drawer }}
          anchor="left"
          variant={mobile ? "temporary" : "persistent"}
          open={this.props.open}
          onClose={() => {
            this.props.openCtl(false);
          }}
        >
          {mobile ? null : <div className={this.props.classes.appBarSpacer} />}

          <div
            className={this.props.classes.headerListItem}
            style={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: 15,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <ListItemText
                style={{ paddingTop: 8 }}
                primary={
                  this.props.account.accountFirstName +
                  " " +
                  this.props.account.accountLastName
                }
              />
              <div style={{ marginTop: 9, }}>
                <SelectRole />
              </div>
              <IconButton
                onClick={() => {
                  signOut().then(() => {
                    this.props.changeAccount({});
                    this.props.history.push("/login");
                  });
                }}
              >
                <ExitToAppIcon />
              </IconButton>
            </div>
            <ListItemText secondary={this.props.account.accountEmail} /> 
          </div>
          <Divider />

          <List
            subheader={
              <ListSubheader>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      flex: 1,
                      fontSize: "1.1rem",
                      fontWeight: "bold",
                      color: "black",
                    }}
                  >
                    My Courses
                  </span>
                  {this.props.selRole == "ta" ? null : (
                    <Button
                      style={{
                        backgroundColor: "green",
                        color: "white",
                        fontSize: "11px",
                        padding: "4px 6px",
                      }}
                      size="small"
                      onClick={() => {
                        this.setState({
                          course: null,
                          courseSettingsOpen: true,
                          clonedCourse: null,
                        });
                      }}
                      startIcon={<AddBoxIcon />}
                    >
                      New
                    </Button>
                  )}
                </div>
              </ListSubheader>
            }
          >
            {Object.values(this.props.courses).map((course) =>
              (course.courseInstructorID === this.props.account.accountEmail || (this.props.account.accountEmail !== undefined && course.tas.includes(this.props.account.accountEmail))) &&
              course?.isActive ? (
                <ListItem
                  key={course.courseID}
                  button
                  selected={
                    this.props.match.params.courseID === course.courseID
                  }
                  onClick={() => {
                    if (course.isActive) {
                      this.props.history.push(
                        "/" + this.props.selRole + "/" +
                          course.courseID +
                          "/" +
                          course.courseActivitySessionID
                      );
                    } else {
                      this.props.history.push("/" + this.props.selRole + "/" + course.courseID);
                    }
                    if (mobile) {
                      this.props.openCtl(false);
                    }
                  }}
                >
                  <ListItemText
                    primary={course.courseName}
                    secondary={
                      course.courseTerm !== undefined ? course.courseTerm : ""
                    }
                  />
                  <Button
                    color="primary"
                    size="small"
                    onClick={() => {
                      const newUrl = "/" + this.props.selRole + "/" + course.courseID;
                      this.props.history.push(newUrl);
                      new Promise((resolve) => {
                        setTimeout(() => {
                          resolve();
                        }, 0);
                      }).then(() => {
                        this.props.handleControls();
                        this.props.startScreenShare();
                      });
                    }}
                    startIcon={<SettingsRemoteIcon />}
                  ></Button>

                  <ListItemSecondaryAction>
                    <IconButton
                      onClick={(event) => {
                        this.setState({
                          course: course.courseID,
                          courseAnchorEl: event.currentTarget,
                        });
                      }}
                    >
                      <MoreVertOutlinedIcon />
                    </IconButton>
                  </ListItemSecondaryAction>
                </ListItem>
              ) : null
            )}
          </List>

          {this.props.selRole !== "instructor" ? null : (
            <List
              subheader={
                <ListSubheader
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  Co-Instructor Courses
                </ListSubheader>
              }
            >
              {this.props.coInstructorCourses &&
              Object.values(this.props.coInstructorCourses).length > 0
                ? Object.values(this.props.coInstructorCourses).map((course) =>
                    course && course.isActive ? (
                      <ListItem
                        key={course.courseID}
                        button
                        selected={
                          this.props.match.params.courseID === course.courseID
                        }
                        onClick={() => {
                          this.props.history.push(
                            "/instructor/" + course.courseID
                          );
                          if (mobile) {
                            this.props.openCtl(false);
                          }
                        }}
                      >
                        <ListItemText
                          primary={course.courseName}
                          secondary={
                            course.courseTerm !== undefined
                              ? course.courseTerm
                              : ""
                          }
                        />
                        <Button
                          color="primary"
                          size="small"
                          onClick={() => {
                            const newUrl = "/instructor/" + course.courseID;
                            this.props.history.push(newUrl);

                            new Promise((resolve) => {
                              setTimeout(() => {
                                resolve();
                              }, 0);
                            }).then(() => {
                              this.props.handleControls();
                            });
                          }}
                          startIcon={<SettingsRemoteIcon />}
                        ></Button>

                        <ListItemSecondaryAction>
                          <IconButton
                            onClick={(event) => {
                              this.setState({
                                course: course.courseID,
                                courseAnchorEl: event.currentTarget,
                              });
                            }}
                          >
                            <MoreVertOutlinedIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ) : null
                  )
                : null}
            </List>
          )}
        {this.props.selRole === "ta" ? null : <>
          <List
            subheader={
              <ListSubheader
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                  color: "black",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  paddingTop: "5px",
                  paddingBottom: "5px",
                  marginBottom: "-10px",
                }}
                onClick={() => {
                  this.setState((prevState) => ({
                    allCoursesShown: !prevState.allCoursesShown,
                  }));
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#f0f0f0";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                }}
              >
                <span>Inactive Courses</span>
                <ListItemText
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {this.state.allCoursesShown ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </div>
                </ListItemText>
              </ListSubheader>
            }
          >
            <Collapse in={this.state.allCoursesShown}>
              <List
                subheader={
                  <ListSubheader
                    style={{
                      paddingTop: "10px",
                      fontSize: "0.9rem",
                      fontWeight: "bold",
                      color: "black",
                    }}
                  >
                    My Inactive Courses
                  </ListSubheader>
                }
              ></List>
              {Object.values(this.props.courses).map((course) =>
                course.courseInstructorID === this.props.account.accountEmail &&
                (!course?.isActive || course?.isActive === undefined) ? (
                  <ListItem
                    key={course.courseID}
                    button
                    selected={
                      this.props.match.params.courseID === course.courseID
                    }
                    onClick={() => {
                      this.props.history.push("/instructor/" + course.courseID);
                      if (mobile) {
                        this.props.openCtl(false);
                      }
                    }}
                  >
                    <ListItemText
                      primary={course.courseName}
                      secondary={
                        course.courseTerm !== undefined ? course.courseTerm : ""
                      }
                    />

                    <ListItemSecondaryAction>
                      <IconButton
                        onClick={(event) => {
                          this.setState({
                            course: course.courseID,
                            courseAnchorEl: event.currentTarget,
                          });
                        }}
                      >
                        <MoreVertOutlinedIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ) : null
              )}
              <List
                subheader={
                  <ListSubheader
                    style={{
                      fontSize: "0.9rem",
                      fontWeight: "bold",
                      color: "black",
                    }}
                  >
                    Inactive Co-Instructor Courses
                  </ListSubheader>
                }
              ></List>
              {this.props.coInstructorCourses &&
              Object.values(this.props.coInstructorCourses).length > 0
                ? Object.values(this.props.coInstructorCourses).map((course) =>
                    !course?.isActive || course?.isActive === undefined ? (
                      <ListItem
                        key={course.courseID}
                        button
                        selected={
                          this.props.match.params.courseID === course.courseID
                        }
                        onClick={() => {
                          this.props.history.push(
                            "/instructor/" + course.courseID
                          );
                          if (mobile) {
                            this.props.openCtl(false);
                          }
                        }}
                      >
                        <ListItemText
                          primary={course.courseName}
                          secondary={
                            course.courseTerm !== undefined
                              ? course.courseTerm
                              : ""
                          }
                        />

                        <ListItemSecondaryAction>
                          <IconButton
                            onClick={(event) => {
                              this.setState({
                                course: course.courseID,
                                courseAnchorEl: event.currentTarget,
                              });
                            }}
                          >
                            <MoreVertOutlinedIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ) : null
                  )
                : null}
            
            </Collapse>
          </List>
    </>}
          <Divider />

          {this.props.account?.accountAdmin ? (
            <List
              subheader={
                <ListSubheader
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: "bold",
                    color: "black",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    paddingTop: "2px",
                    paddingBottom: "2px",
                    marginBottom: "-10px",
                  }}
                  onClick={() => {
                    this.setState((prevState) => ({
                      adminDropdown: !prevState.adminDropdown,
                    }));
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#f0f0f0";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }}
                >
                  <span>Admin Controls</span>
                  <ListItemText
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {this.state.adminDropdown ? (
                        <ExpandLessIcon />
                      ) : (
                        <ExpandMoreIcon />
                      )}
                    </div>
                  </ListItemText>
                </ListSubheader>
              }
            >
              <Collapse in={this.state.adminDropdown}>
                <ListItemButton
                  
                  onClick={() => {
                    this.setState({adminInterfaceOpen: true});
                  }}
                >
                  <ListItemText>Manage Courses</ListItemText>
                </ListItemButton>
                <ListSubheader
                  style={{
                    // paddingTop: "10px",
                    fontSize: "1.0rem",
                    // fontWeight: "bold",
                    color: "black",
                  }}
                >
                  Add instructor:
                </ListSubheader>
                <div 
                  style={{ 
                    display: "flex", 
                    flexDirection: "row", 
                    alignItems: "center", 
                    marginBottom: 10,
                  }}
                >
                  <TextField
                    // className={this.props.classes.search}
                    style={{ marginLeft: "12px "}}
                    variant="outlined"
                    error={this.state.addInstructorError}
                    helperText={this.state.addInstructorHelper}
                    size="small"
                    label={"Email"}
                    value={this.state.addInstructorEmail}
                    onChange={(event) => {
                      this.setState({ 
                        addInstructorEmail: event.target.value,
                        addInstructorError: false,
                        addInstructorHelper: "",
                      });
                    }}
                  />
                  <Tooltip title="Add" placement="top">
                    <IconButton
                      size="small"
                      style={{ margin:"auto"}}
                      onClick={async() => {
                        const success = await addInstructor({email: this.state.addInstructorEmail.trim()});

                        if (success) {
                          this.setState({addInstructorHelper: "Instructor has been added"});
                        } else {
                          this.setState({
                            addInstructorHelper: "User already exists",
                            addInstructorError: true,
                          });
                        }
                      }}
                    >
                      <CheckIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                </div>
                <ListSubheader
                  style={{
                    // paddingTop: "10px",
                    fontSize: "1.0rem",
                    // fontWeight: "bold",
                    color: "black",
                  }}
                >
                  Change account type of user:
                </ListSubheader>
                <TextField
                  className={this.props.classes.search}
                  variant="outlined"
                  size="small"
                  label={"Email"}
                  value={this.state.search}
                  onChange={(event) => {
                    this.setState({ search: event.target.value });
                    if (event.target.value === "") {
                      this.setState(() => ({
                        searchResult: {},
                      }));
                      return;
                    }
                    searchAccount(event.target.value).then((account) => {
                      this.setState(() => ({
                        searchResult: account,
                        enrollLoading: true,
                      }));
                    });
                  }}
                />

                {this.state.searchResult.firstName !== undefined ? (
                  <List style={{ padding: "0px" }}>
                    <ListItem key={this.state.searchResult.id}>
                      <ListItemText
                        primary={
                          this.state.searchResult.firstName +
                          " " +
                          this.state.searchResult.lastName
                        }
                        secondary={this.state.searchResult.id}
                        primaryTypographyProps={{
                          style: { fontSize: "0.9rem" },
                        }}
                        secondaryTypographyProps={{
                          style: { fontSize: "0.8rem" },
                        }}
                      />
                      <Select
                        value={this.state.searchResult.type || "student"}
                        onChange={(event) => {
                          const selectedRole = event.target.value;
                          this.setState({
                            searchResultConfirmData: {
                              accountID: this.state.searchResult.id,
                              type: selectedRole,
                            },
                            showSearchResultConfirmDialog: true,
                          });
                        }}
                        style={{ marginLeft: "auto", fontSize: "0.8rem" }}
                      >
                        <MenuItem value="student">Student</MenuItem>
                        <MenuItem value="ta">TA</MenuItem>
                        <MenuItem value="instructor">Instructor</MenuItem>
                      </Select>
                    </ListItem>
                  </List>
                ) : null}
              </Collapse>
            </List>
          ) : null}
          {this.props.account?.accountAdmin ? <Divider /> : null}
        </Drawer>

        <Dialog
          fullScreen={mobile}
          fullWidth
          maxWidth="sm"
          open={this.state.showSearchResultConfirmDialog}
          onClose={(event, reason) => {
            if (reason === "backdropClick") {
              return;
            }
          }}
        >
          <DialogContent>
            <Typography variant="h6" style={{ marginBottom: "16px" }}>
              Change {this.state.searchResult.id}'s account to{" "}
              {this.state.searchResultConfirmData?.type}?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                this.setState({ showSearchResultConfirmDialog: false });
              }}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={() => {
                setAccount(this.state.searchResultConfirmData);

                this.setState({
                  showSearchResultConfirmDialog: false,
                  searchResult: {},
                  search: "",
                });
              }}
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

        <Menu
          anchorEl={this.state.courseAnchorEl}
          open={Boolean(this.state.courseAnchorEl)}
          onClose={() => {
            this.setState({
              course: null,
              courseAnchorEl: null,
              clonedCourse: null,
            });
          }}
        >
          <MenuItem
            button={true}
            onClick={() => {
              this.setState({
                courseSettingsOpen: true,
                courseAnchorEl: null,
              });
            }}
          >
            Settings
          </MenuItem>

          {(this.props.courses?.[this.state.course]?.geofencing ||
            this.props.coInstructorCourses?.[this.state.course]
              ?.geofencing) && (
            <MenuItem
              button={true}
              disabled={
                !this.props.courses?.[this.state.course]
                  ?.courseActivitySessionID &&
                !this.props.coInstructorCourses?.[this.state.course]
                  ?.courseActivitySessionID
              }
              onClick={() => {
                this.setState({
                  courseOverrideOpen: true,
                  courseAnchorEl: null,
                });
              }}
            >
              Geo Override
            </MenuItem>
          )}

          {(this.props.courses?.[this.state.course]?.lockedPolls ||
            this.props.coInstructorCourses?.[this.state.course]
              ?.lockedPolls) && 
            ( this.props.selRole === "instructor" ||
            this.props.courses?.[this.state.course]?.taPrivileges?.includes("Open Lockout Polls")) && (
            <MenuItem
              button={true}
              onClick={() => {
                this.setState({
                  courseLockoutOpen: true,
                  courseAnchorEl: null,
                });
              }}
            >
              Lockout Override
            </MenuItem>
          )}
          {(this.props.selRole === "instructor" || 
            this.props.courses?.[this.state.course]?.taPrivileges?.includes("View Enrollment")) && 
            <MenuItem
              button={true}
              onClick={() => {
                this.setState({
                  courseEnrollmentOpen: true,
                  courseAnchorEl: null,
                });
              }}
            >
              Enrollment
            </MenuItem>
          }
          {(this.props.selRole === "instructor" || 
            this.props.courses?.[this.state.course]?.taPrivileges?.includes("Export Votes")) && 
            <MenuItem
              button={true}
              onClick={() => {
                this.setState({
                  courseExportOpen: true,
                  courseAnchorEl: null,
                  courseExportSessions: 1,
                });
              }}
            >
              Export votes
            </MenuItem>
          }
          {this.props.selRole === "ta" ? null : 
          <MenuItem
            button={true}
            onClick={async () => {
              const selectedCourse =
                this.props.courses?.[this.state.course] ||
                this.props.coInstructorCourses?.[this.state.course];
              const newCourseCode = await generateCourseCode();

              // console.log("CLONE CLICKED");
              // console.log("selectedCourse:", selectedCourse);
              const clonedCourse = {
                ...selectedCourse,
                isActive: selectedCourse.isActive.checked,
                courseName: selectedCourse.courseName + " (CLONE)",
                courseID: "",
                courseCode: newCourseCode,
                courseTerm: "",
                courseActivitySessionID: "",
                courseActivityPollID: "",
                includedSessions: [],
              }
              // console.log("clonedCourse object to setState:", clonedCourse);
              this.setState({
                courseSettingsOpen: true,
                courseAnchorEl: null,
                clonedCourse: clonedCourse
              });
            }}
          >
            Clone
          </MenuItem>}
        </Menu>

        <InstructorCourseSettings
          key={"Settings New" + this.state.courseSettingsOpen}
          open={this.state.courseSettingsOpen}
          openCtl={(open) => {
            this.setState({ courseSettingsOpen: open, clonedCourse: null });
          }}
          adminView={false}
          anonCourseDialog={this.state.anonCourseDialogOpen}
          openAnonCourseDialog={(open) => {
            this.setState({anonCourseDialogOpen: open});
          }}
          openRefreshDialog={(open) => {
            this.setState({ openRefreshDialog: open });
          }}
          newCourse={this.state.course === null || this.state.clonedCourse !== null}
          course={
            this.state.clonedCourse ||
            this.props.courses?.[this.state.course] ||
            this.props.coInstructorCourses?.[this.state.course]
          }
          initGoogleDrive={async (courseID) => {
            await this.props.initGoogleDrive(courseID);
          }}
          setScreenshotEnabledDevice={(boolean) =>
            this.props.setScreenshotEnabledDevice(boolean)
          }
        />

        {this.props.courses?.[this.state.course] === undefined &&
        this.props.coInstructorCourses?.[this.state.course] ===
          undefined ? null : (
          <InstructorCourseOverride
            key={"Override" + this.state.courseOverrideOpen}
            open={this.state.courseOverrideOpen}
            openCtl={(open) => {
              this.setState({ courseOverrideOpen: open });
            }}
            course={
              this.props.courses?.[this.state.course] ||
              this.props.coInstructorCourses?.[this.state.course]
            }
            setRerender={this.props.setRerender}
          />
        )}

        {this.props.courses?.[this.state.course] === undefined &&
        this.props.coInstructorCourses?.[this.state.course] ===
          undefined ? null : (
          <InstructorLockoutMenu
            key={"Lockout" + this.state.courseLockoutOpen}
            open={this.state.courseLockoutOpen}
            openCtl={(open) => {
              this.setState({ courseLockoutOpen: open });
            }}
            setOpenSelect={(open) => {
              this.setState({
                //courseLockoutOpen: !open,
                courseSelectUnlockOpen: open,
              });
            }}
            selStudent={this.state.selectedStudent}
            unlockStudent={this.state.unlockStudent}
            setUnlockStudent={(unlock) => {
              this.setState({ unlockStudent: unlock });
            }}
            setSelStudent={(studentEmail) => {
              this.setState({ selectedStudent: studentEmail });
            }}
            course={
              this.props.courses?.[this.state.course] ||
              this.props.coInstructorCourses?.[this.state.course]
            }
            setRerender={this.props.setRerender}
          />
        )}

        {this.props.courses?.[this.state.course] === undefined &&
        this.props.coInstructorCourses?.[this.state.course] ===
          undefined ? null : (
          <InstructorUnlockSelect
            key={"UnlockSelect" + this.state.courseSelectUnlockOpen}
            open={this.state.courseSelectUnlockOpen}
            openSelect={(open) => {
              this.setState({
                //courseLockoutOpen: !open,
                courseSelectUnlockOpen: open,
              });
            }}
            selectedStudent={this.state.selectedStudent}
            setUnlockStudent={(unlock) => {
              this.setState({ unlockStudent: unlock });
            }}
            setRerender={this.props.setRerender}
            course={
              this.props.courses?.[this.state.course] ||
              this.props.coInstructorCourses?.[this.state.course]
            }
          />
        )}

        {this.props.courses?.[this.state.course] === undefined &&
        this.props.coInstructorCourses?.[this.state.course] ===
          undefined ? null : (
          <InstructorCourseEnrollment
            key={"Enrollment" + this.state.courseEnrollmentOpen}
            open={this.state.courseEnrollmentOpen}
            openCtl={(open) => {
              this.setState({ courseEnrollmentOpen: open });
            }}
            course={
              this.props.courses?.[this.state.course] ||
              this.props.coInstructorCourses?.[this.state.course]
            }
          />
        )}

        {this.props.courses?.[this.state.course] === undefined &&
        this.props.coInstructorCourses?.[this.state.course] ===
          undefined ? null : (
          <InstructorCourseExport
            key={"Export" + this.state.courseExportOpen}
            open={this.state.courseExportOpen}
            openCtl={(open) => {
              this.setState({ courseExportOpen: open });
            }}
            openSelect={(open) => {
              this.setState({
                courseExportOpen: open,
                exportSelectOpen: !open,
              });
            }}
            correctSet={(correct) => {
              this.setState({
                correctOnly: correct,
              });
            }}
            anonSet={(anon) => {
              this.setState({
                anonVotes: anon,
              });
            }}
            course={
              this.props.courses?.[this.state.course] ||
              this.props.coInstructorCourses?.[this.state.course]
            }
            courseSessions={this.state.courseExportSessions}
          />
        )}

        {this.props.courses?.[this.state.course] === undefined &&
        this.props.coInstructorCourses?.[this.state.course] ===
          undefined ? null : (
          <InstructorCourseExportSelect
            key={"MoreExport" + this.state.exportSelectOpen}
            open={this.state.exportSelectOpen}
            openCtl={(open) => {
              this.setState({ exportSelectOpen: open });
            }}
            correctOnly={this.state.correctOnly}
            anonVotes={this.state.anonVotes}
            course={
              this.props.courses?.[this.state.course] ||
              this.props.coInstructorCourses?.[this.state.course]
            }
            courseSessions={this.state.courseExportSessions}
          />
        )}
        <InstructorRefreshDialog
          open={this.state.openRefreshDialog}
          openCtl={(open) => {
            this.setState({ openRefreshDialog: open, });
          }}
        />
        <AdminInterface 
          open={this.state.adminInterfaceOpen}
          openCtl={(open) => {
            this.setState({ adminInterfaceOpen: open });
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeAccount: (data) => dispatch(changeAccount(data)),
    changeSelRole: (data) => dispatch(changeSelRole(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(InstructorMenu))
  )
);